import createIcon from '../../createIcon';

/**
 * @component @name SsidChart
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgNS40N0wxMiAxMkw3LjYyIDcuNjJMMyAxMVY4LjUyTDcuODMgNUwxMi4yMSA5LjM4TDIxIDNWNS40N1pNMjEgMTVIMTYuM0wxMi4xMyAxOC4zNEw2IDEyLjQxTDMgMTQuNTRWMTdMNS44IDE1TDEyIDIxTDE3IDE3SDIxVjE1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SsidChart = createIcon('SsidChart', [
  [
    'path',
    {
      d: 'M21 5.47L12 12L7.62 7.62L3 11V8.52L7.83 5L12.21 9.38L21 3V5.47ZM21 15H16.3L12.13 18.34L6 12.41L3 14.54V17L5.8 15L12 21L17 17H21V15Z',
      key: '4sqcb7',
    },
  ],
]);

export default SsidChart;
